import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Checkbox,
  RadioGroup,
  FormControlLabel,
  Radio,
  Rating,
  TextField,
  Button,
  IconButton,
  Card,
  Paper,
  Breadcrumbs,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom"; // At the top
import { ArrowBack, CalendarToday } from "@mui/icons-material";
import Swal from "sweetalert2";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  AssessmentAnswerGet,
  postData,
} from "../../store/reducers/Formapireducer";
import toast from "react-hot-toast";
import { Formik, Form } from "formik";
import * as Yup from "yup";

export default function SkillExam() {
  const location = useLocation();
  const navigate = useNavigate(); // Inside SkillExam component

  const dispatch = useDispatch();

  const navigateBack = () => {
    navigate(-1);
  };
  const skillName = location.state?.skill || "Unknown Skill";
  //const today = new Date().toLocaleDateString();
  const today = new Date().toLocaleDateString("en-GB");

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  //const [answers, setAnswers] = useState({});
  const [answers1, setAnswers1] = useState([]);
  const [preview, setPreview] = useState(false);

  // const handleAnswer = (id, value) => {
  //   setAnswers((prev) => ({ ...prev, [id]: value }));
  // };

  const renderQuestion = (q, setFieldValue, values) => {
    switch (q.AnswerType) {
      case "1/4":
        return (
          <RadioGroup
            value={values[q.Code] || ""}
            onChange={(e) => {
              setFieldValue(q.Code, e.target.value);
            }}
          >
            {/* {q.options.map((opt) => ( */}
            <FormControlLabel
              value={q.Option1}
              control={<Radio />}
              label={q.Option1}
            />
            <FormControlLabel
              value={q.Option2}
              control={<Radio />}
              label={q.Option2}
            />
            <FormControlLabel
              value={q.Option3}
              control={<Radio />}
              label={q.Option3}
            />
            <FormControlLabel
              value={q.Option4}
              control={<Radio />}
              label={q.Option4}
            />
            {/* ))} */}
          </RadioGroup>
        );

      case "Any/4":
        return (
          <React.Fragment>
            <RadioGroup
              value={values[q.Code] || ""}
              onChange={(e) => {
                setFieldValue(q.Code, e.target.value);
              }}
            >
              {/* {q.options.map((opt) => ( */}
              <FormControlLabel
                value={q.Option1}
                control={<Radio />}
                label={q.Option1}
              />
              <FormControlLabel
                value={q.Option2}
                control={<Radio />}
                label={q.Option2}
              />
              <FormControlLabel
                value={q.Option3}
                control={<Radio />}
                label={q.Option3}
              />
              <FormControlLabel
                value={q.Option4}
                control={<Radio />}
                label={q.Option4}
              />
              {/* ))} */}
            </RadioGroup>
          </React.Fragment>
        );

      case "Text":
        return (
          <TextField
            fullWidth
            multiline
            rows={q.Code.length > 40 ? 4 : 1}
            variant="outlined"
            placeholder="Enter your answer"
            value={values[q.Code] || ""}
            onChange={(e) => {
              setFieldValue(q.Code, e.target.value);
            }}
          />
        );

      case "Number":
        return (
          <TextField
            type="number"
            fullWidth
            variant="outlined"
            placeholder="Enter only numbers"
            value={values[q.Code] || ""}
            onChange={(e) => {
              setFieldValue(q.Code, e.target.value);
            }}
          />
        );

      case "10Rates":
        return (
          <RadioGroup
            value={values[q.Code] || ""}
            onChange={(e) => {
              setFieldValue(q.Code, e.target.value);
            }}
          >
            {/* {q.options.map((opt) => ( */}
            <FormControlLabel
              value={q.Option1}
              control={<Radio />}
              label={q.Option1}
            />
            <FormControlLabel
              value={q.Option2}
              control={<Radio />}
              label={q.Option2}
            />
            <FormControlLabel
              value={q.Option3}
              control={<Radio />}
              label={q.Option3}
            />
            <FormControlLabel
              value={q.Option4}
              control={<Radio />}
              label={q.Option4}
            />
            <FormControlLabel
              value={q.Option5}
              control={<Radio />}
              label={q.Option5}
            />
            <FormControlLabel
              value={q.Option6}
              control={<Radio />}
              label={q.Option6}
            />
            <FormControlLabel
              value={q.Option7}
              control={<Radio />}
              label={q.Option7}
            />
            <FormControlLabel
              value={q.Option8}
              control={<Radio />}
              label={q.Option8}
            />
            <FormControlLabel
              value={q.Option9}
              control={<Radio />}
              label={q.Option9}
            />
            <FormControlLabel
              value={q.Option10}
              control={<Radio />}
              label={q.Option10}
            />
            {/* ))} */}
          </RadioGroup>
        );

      case "5Rates":
        return (
          <RadioGroup
            value={values[q.Code] || ""}
            onChange={(e) => {
              setFieldValue(q.Code, e.target.value);
            }}
          >
            {/* {q.options.map((opt) => ( */}
            <FormControlLabel
              value={q.Option1}
              control={<Radio />}
              label={q.Option1}
            />
            <FormControlLabel
              value={q.Option2}
              control={<Radio />}
              label={q.Option2}
            />
            <FormControlLabel
              value={q.Option3}
              control={<Radio />}
              label={q.Option3}
            />
            <FormControlLabel
              value={q.Option4}
              control={<Radio />}
              label={q.Option4}
            />
            <FormControlLabel
              value={q.Option5}
              control={<Radio />}
              label={q.Option5}
            />
            {/* ))} */}
          </RadioGroup>
        );

      case "T/F":
        return (
          <RadioGroup
            row
            value={values[q.Code] || ""}
            onChange={(e) => setFieldValue(q.Code, e.target.value)}
          >
            <FormControlLabel value="True" control={<Radio />} label="True" />
            <FormControlLabel value="False" control={<Radio />} label="False" />
          </RadioGroup>
        );

      case "Y/N":
        return (
          <RadioGroup
            row
            value={values[q.Code] || ""}
            onChange={(e) => setFieldValue(q.Code, e.target.value)}
          >
            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="No" control={<Radio />} label="No" />
          </RadioGroup>
        );

      default:
        return null;
    }
  };

  const handlePreview = () => setPreview(true);
  const handleBackToQuestions = () => setPreview(false);
  //TIMER
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    setTimer(Date.now());

    dispatch(
      AssessmentAnswerGet({
        data: { AssessmentID: AssessmentID, EmployeeID: EmployeeID },
      })
    );
  }, []);

  const data = useSelector((state) => state.formApi.SkilGlowAnswerGetData);
  const status = useSelector((state) => state.formApi.SkilGlowAnswerGetStatus);
  const getLoading = useSelector(
    (state) => state.formApi.SkilGlowAnswerGetLoading
  );
  //VALIDATION SCHEMA
  const validationSchema = Yup.object().shape(
    data.reduce((acc, q) => {
      if (q.AnswerType === "Text") {
        acc[q.Code] = Yup.string().required("This question is required");
      } else if (q.AnswerType === "Number") {
        acc[q.Code] = Yup.number()
          .typeError("Must be a number")
          .min(0, "No negative numbers")
          .required("This question is required");
      } else {
        // Default for all RadioGroup types
        acc[q.Code] = Yup.string().required("This question is required");
      }
      return acc;
    }, {})
  );

  //SAVE FUNCTION
  const params = useParams();

  const recID = params.id;
  const accessID = params.accessID;
  const screenName = params.screenName;
  const mode = params.Mode;
  const CompanyID = sessionStorage.getItem("compID");
  const AssessmentID = params.parentID1;

  const EmployeeID = sessionStorage.getItem("EmpId");
  const state = location.state || {};

  // const AssessmentSaveFn = async (values) => {

  //   let action = mode === "A" ? "insert" : "view";

  //   const totalSeconds = Math.floor((Date.now() - timer) / 1000);
  //   let minutes = Math.floor(totalSeconds / 60);
  //   if (minutes === 0 && totalSeconds > 0) {
  //     minutes = 1;
  //   }

  //   const idata = {
  //     RecordID: "-1",
  //     EmpassscheduledRecordID: recID,
  //     EmpRecordID: EmployeeID,
  //     AssessmentRecordID: AssessmentID,
  //     Duration: minutes,
  //     AnswerDate: new Date().toISOString().split("T")[0],
  //     Details: data.map((q) => ({
  //       QuestiongroupRecordID: q.QuestionGroupID,
  //       QuestionsRecordID: q.RecordID,
  //       SelectedOption: values[q.Code] || "",
  //       SelectedRate: "",
  //     })),
  //   };
  //   const response = await dispatch(
  //     postData({ accessID: "TR285", action, idata })
  //   );
  //   if (response.payload.Status == "Y") {
  //     toast.success(response.payload.Msg);
  //     navigate(-1);
  //   } else {
  //     toast.error(response.payload.Msg ? response.payload.Msg : "Error");
  //   }
  // };
  const AssessmentSaveFn = async (values) => {
    let action = mode === "A" ? "insert" : "view";

    const totalSeconds = Math.floor((Date.now() - timer) / 1000);
    let minutes = Math.floor(totalSeconds / 60);
    if (minutes === 0 && totalSeconds > 0) minutes = 1;

    const idata = {
      RecordID: "-1",
      EmpassscheduledRecordID: recID,
      EmpRecordID: EmployeeID,
      AssessmentRecordID: AssessmentID,
      Duration: minutes,
      AnswerDate: new Date().toISOString().split("T")[0],
      Details: data.map((q) => {
        const selectedOption = values[q.Code] || "";
        let selectedRate = "";

        // Match selected option with its corresponding rate
        for (let i = 1; i <= 10; i++) {
          if (q[`Option${i}`] && selectedOption === q[`Option${i}`]) {
            selectedRate = q[`Rate${i}`] || "";
            break;
          }
        }

        // Special handling for T/F and Y/N
        if (
          (q.AnswerType === "T/F" || q.AnswerType === "Y/N") &&
          selectedRate === ""
        ) {
          if (selectedOption === q.Option1) selectedRate = q.Rate1 || "";
          else if (selectedOption === q.Option2) selectedRate = q.Rate2 || "";
        }

        // Include all options and rates in the object
        const optionsAndRates = {};
        for (let i = 1; i <= 10; i++) {
          optionsAndRates[`Option${i}`] = q[`Option${i}`] || "";
          optionsAndRates[`Rate${i}`] = q[`Rate${i}`] || "0";
        }

        return {
          QuestiongroupRecordID: q.QuestionGroupID,
          QuestionsRecordID: q.RecordID,
          SelectedOption: selectedOption,
          SelectedRate: selectedRate,
          ...optionsAndRates, // Spread all options and rates
        };
      }),
    };

    const response = await dispatch(
      postData({ accessID: "TR285", action, idata })
    );

    if (response.payload.Status == "Y") {
      toast.success(response.payload.Msg);
      navigate(-1);
    } else {
      toast.error(response.payload.Msg ? response.payload.Msg : "Error");
    }
  };

  const fnLogOut = (props) => {
    Swal.fire({
      title: `Do you want ${props}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate("/Apps/TR026/Department");
        }
      } else {
        return;
      }
    });
  };

  const isNonMobile = useMediaQuery("(min-width:600px)");

  const { toggleSidebar, broken, rtl } = useProSidebar();
  return (
    <>
      <React.Fragment
        sx={{
          p: 2,
          height: "100vh",
        }}
      >
        {/* BREADCRUMBS */}
        <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>
          <Box display="flex" justifyContent="space-between" p={2}>
            <Box display="flex" borderRadius="3px" alignItems="center">
              {broken && !rtl && (
                <IconButton onClick={() => toggleSidebar()}>
                  <MenuOutlinedIcon />
                </IconButton>
              )}
              <Box
                display={isNonMobile ? "flex" : "none"}
                borderRadius="3px"
                alignItems="center"
              >
                <Breadcrumbs
                  maxItems={3}
                  aria-label="breadcrumb"
                  separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                >
                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default" }}
                    onClick={() =>
                      navigate("/Apps/TR308/List%20Of%20Assessment%20Type")
                    }
                  >
                    List Of Assessment Type({state.BreadCrumb1})
                  </Typography>

                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default" }}
                    onClick={() => navigate(-1)}
                  >
                    List Of{" "}
                    {params.parentID2 === "AP"
                    ? "Appraisal"
                    : params.parentID2 === "CL"
                    ? "Compliance"
                    : params.parentID2 === "SK"
                    ? "Assessment"
                    : params.parentID2 === "SV"
                    ? "Survey"
                    : params.parentID2 === "FB"
                    ? "Feedback"
                    : ""}
                  ({state.BreadCrumb2})
                    
                  </Typography>
                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default" }}
                  >
                    {/* {params.parentID2 === "AP" ? "Appraisal" : "Assessment"} */}
                    {params.parentID2 === "AP"
                    ? "Appraisal"
                    : params.parentID2 === "CL"
                    ? "Compliance"
                    : params.parentID2 === "SK"
                    ? "Assessment"
                    : params.parentID2 === "SV"
                    ? "Survey"
                    : params.parentID2 === "FB"
                    ? "Feedback"
                    : ""}
                  </Typography>
                </Breadcrumbs>
              </Box>
            </Box>

            <Box display="flex">
              <Tooltip title="Close">
                <IconButton onClick={() => fnLogOut("Close")} color="error">
                  <ResetTvIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Logout">
                <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                  <LogoutOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </Paper>

        {!getLoading ? (
          <Paper elevation={3} sx={{ margin: "10px", padding: "10px" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between",alignItems:"end" }}>
              <Box>
                <Typography variant="h4" gutterBottom>
                  {params.parentID2 === "AP"
                    ? "Appraisal"
                    : params.parentID2 === "CL"
                    ? "Compliance"
                    : params.parentID2 === "SK"
                    ? "Assessment"
                    : params.parentID2 === "SV"
                    ? "Survey"
                    : params.parentID2 === "FB"
                    ? "Feedback"
                    : ""}{" "}
                  - <b>{state.BreadCrumb2}</b>
                  {/* Assessment - <b>{state.BreadCrumb2}</b> */}
                </Typography>
                {/* <Typography variant="subtitle1">
                  Question Group - <b>{state.BreadCrumb2}</b>
                </Typography> */}
              </Box>
              <Box>
                <IconButton sx={{ gap: "5px" }}>
                  <CalendarToday />
                  <Typography variant="subtitle1">{today}</Typography>
                </IconButton>
              </Box>
            </Box>
            <Formik
              initialValues={data.reduce((acc, q) => {
                acc[q.Code] = ""; // default empty
                return acc;
              }, {})}
              //validationSchema={validationSchema}
              onSubmit={(values, { resetForm }) => {
                setTimeout(() => {
                  AssessmentSaveFn(values, resetForm);
                }, 100);
              }}
              enableReinitialize={true}
              validationSchema={validationSchema}
            >
              {({
                handleChange,
                values,
                errors,
                touched,
                setFieldValue,
                handleSubmit,
                setTouched,
              }) => (
                <Form onSubmit={handleSubmit}>
                  {!preview ? (
                    <>
                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                          {currentQuestionIndex + 1}.
                          {data.length > 0
                            ? data[currentQuestionIndex]["Question"]
                            : ""}
                        </Typography>
                        {data.length > 0
                          ? renderQuestion(
                              data[currentQuestionIndex],
                              setFieldValue,
                              values
                            )
                          : ""}
                        {/* {} */}

                        {errors[data[currentQuestionIndex]?.Code] &&
                          touched[data[currentQuestionIndex]?.Code] && (
                            <Typography color="error" variant="body2">
                              {errors[data[currentQuestionIndex]?.Code]}
                            </Typography>
                          )}
                      </Box>

                      <Box mt={4} display="flex" justifyContent="flex-end">
                        <Button
                          variant="outlined"
                          disabled={currentQuestionIndex === 0}
                          onClick={() => setCurrentQuestionIndex((i) => i - 1)}
                          sx={{ mr: 2 }}
                        >
                          Previous
                        </Button>
                        {/* <Button
                          variant="outlined"
                          sx={{ mr: 2 }}
                          onClick={handlePreview}
                        >
                          Preview{" "}
                          {!preview
                            ? `${currentQuestionIndex + 1}/${data.length}` // current question/total
                            : `${Object.keys(values).length}/${
                                data.length
                              }`}{" "}
                        </Button> */}
                        <Button
                          variant="outlined"
                          sx={{ mr: 2 }}
                          onClick={() => {
                            const q = data[currentQuestionIndex];
                            const answer = values[q.Code];
                            const error = errors[q.Code];

                            if (!answer || error) {
                              // mark current question as touched so validation error shows
                              setTouched({ [q.Code]: true });
                              return;
                            }

                            // ✅ Force Formik to commit the latest value before preview
                            setFieldValue(q.Code, answer, true);

                            handlePreview();
                          }}
                        >
                          Preview{" "}
                          {!preview
                            ? `${currentQuestionIndex + 1}/${data.length}` // current question/total
                            : `${
                                Object.values(values).filter(
                                  (v) => v !== "" && v !== undefined && v !== 0
                                ).length
                              }/${data.length}`}{" "}
                        </Button>

                        <Box>
                          {/* <Button
                            variant="contained"
                            onClick={() => {
                              const isLast =
                                currentQuestionIndex === data.length - 1;
                              if (!isLast) {
                                setCurrentQuestionIndex((i) => i + 1);
                              } else {
                                handleSubmit();
                              }
                            }}
                          >
                            {currentQuestionIndex === data.length - 1
                              ? "Finish"
                              : "Next"}
                          </Button> */}
                          <Button
                            variant="contained"
                            onClick={() => {
                              //TOAST TO PREVENT GOING TO NEXT QUESTION..
                              const q = data[currentQuestionIndex];
                              const answer = values[q.Code];
                              const error = errors[q.Code];

                              if (!answer || error) {
                                // toast.error(
                                //   "Please answer this question before continuing."
                                // );

                                setTouched({ [q.Code]: true });
                                return;
                              }
                              //TOAST TO PREVENT GOING TO NEXT QUESTION..

                              const isLast =
                                currentQuestionIndex === data.length - 1;
                              if (!isLast) {
                                setCurrentQuestionIndex((i) => i + 1);
                              } else {
                                handleSubmit();
                              }
                            }}
                          >
                            {currentQuestionIndex === data.length - 1
                              ? "Finish"
                              : "Next"}
                          </Button>
                        </Box>
                      </Box>
                    </>
                  ) : (
                    <>
                      <Box mt={4}>
                        <Typography variant="h5">
                          Answered Questions -
                          {/* <b>
                            {!preview
                              ? `${currentQuestionIndex + 1}/${data.length}` // current question/total
                              : `${Object.keys(answers).length}/${
                                  data.length
                                }`}{" "}
                          </b> */}
                          <b>
                            {!preview
                              ? `${currentQuestionIndex + 1}/${data.length}` // current question/total
                              : `${
                                  Object.values(values).filter(
                                    (v) =>
                                      v !== "" && v !== undefined && v !== 0
                                  ).length
                                }/${data.length}`}{" "}
                          </b>
                        </Typography>

                        {data.map((q, i) => (
                          <Box key={q.Code} mt={3}>
                            <Typography variant="subtitle1">
                              {i + 1}. {q.Question}
                            </Typography>
                            <Typography variant="body1">
                              {values[q.Code] && values[q.Code] !== ""
                                ? values[q.Code]
                                : "(No answer)"}
                            </Typography>
                          </Box>
                        ))}
                      </Box>

                      <Box mt={4}>
                        <Button
                          variant="contained"
                          onClick={handleBackToQuestions}
                        >
                          Back to Questions
                        </Button>
                      </Box>
                    </>
                  )}
                </Form>
              )}
            </Formik>
          </Paper>
        ) : (
          false
        )}
      </React.Fragment>
    </>
  );
}
